import React, { ComponentProps } from 'react'
import * as RadixTooltip from '@radix-ui/react-tooltip'
import { TooltipArrow, TooltipContent } from './Tooltip.styles'
import { useState } from 'react'

type TooltipOwnProps = ComponentProps<typeof TooltipContent>
export type TooltipProps = TooltipOwnProps & {
  text: string
  instant?: boolean
}

export const Tooltip = ({
  children,
  text,
  side = 'top',
  align = 'center',
  sideOffset = 4,
  instant = false,
  ...props
}: TooltipProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <RadixTooltip.Root open={isOpen} delayDuration={instant ? 10 : 700}>
      <RadixTooltip.Trigger
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
        asChild
      >
        {children}
      </RadixTooltip.Trigger>
      <TooltipContent
        portalled
        avoidCollisions
        side={side}
        align={align}
        sideOffset={sideOffset}
        {...props}
      >
        {text}
        <TooltipArrow offset={4} />
      </TooltipContent>
    </RadixTooltip.Root>
  )
}

Tooltip.displayName = 'Tooltip'
